import { ResellerResponseDTO } from '@core/api/dtos/response/reseller/reseller'
import { Reseller } from '@core/api/entities/reseller'

export class ResellerMapper {
	static toEntity = (dto: ResellerResponseDTO): Reseller => {
		return new Reseller({
			id: dto.id,
			name: dto.name,
		})
	}

	static toEntities = (dtos: ResellerResponseDTO[]): Reseller[] => {
		return dtos.map(ResellerMapper.toEntity)
	}
}
